import { useNavigate, useRouterState } from '@tanstack/react-router';

import { FEATURES, useFeature } from '@/features/feature-flags';
import { cn } from '@/lib/utils';

const views = [
  { label: 'World Model', route: '/world-model' },
  { label: 'Memory', route: '/echonotes' },
] as const;

export function MemoryViewSwitcher() {
  const hasFeature = useFeature();
  const navigate = useNavigate();
  const pathname = useRouterState().location.pathname;

  if (!hasFeature(FEATURES.WORLD_MODEL)) {
    return (
      <span className="text-sm font-medium ml-1.5 whitespace-nowrap">
        Memory
      </span>
    );
  }

  return (
    <div className="flex gap-0.5 bg-secondary rounded-lg p-0.5 whitespace-nowrap">
      {views.map((view) => {
        const isActive = pathname.startsWith(view.route);
        return (
          <button
            key={view.route}
            type="button"
            onClick={() => navigate({ to: view.route })}
            className={cn(
              'px-3 py-1 text-sm rounded-md transition-colors',
              isActive
                ? 'bg-surface text-foreground shadow-sm font-medium'
                : 'text-foreground-muted hover:text-foreground'
            )}
          >
            {view.label}
          </button>
        );
      })}
    </div>
  );
}
